
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { StudentFormValues } from "../schema/studentSchema";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "@/hooks/useTranslations";

interface AssessmentTabProps {
  form: UseFormReturn<StudentFormValues>;
}

export const AssessmentTab = ({ form }: AssessmentTabProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslations("students");
  
  return (
    <div className="space-y-4">
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="height"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.height")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.height")} {...field} className="dark:bg-gray-700 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage className="dark:text-red-400" />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="weight"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.weight")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.weight")} {...field} className="dark:bg-gray-700 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage className="dark:text-red-400" />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="medical_conditions"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-gray-200">{t("form.medicalConditions")}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={t("form.medicalConditions")} 
                {...field} 
                className="resize-none min-h-[100px] dark:bg-gray-700 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-400"
              />
            </FormControl>
            <FormMessage className="dark:text-red-400" />
          </FormItem>
        )}
      />
      
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="initial_assessment_date"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.initialAssessmentDate")}</FormLabel>
              <FormControl>
                <Input type="date" className="p-2 dark:bg-gray-700 dark:border-gray-700 dark:text-white" {...field} />
              </FormControl>
              <FormMessage className="dark:text-red-400" />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="fitness_level"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.fitnessLevel")}</FormLabel>
              <Select 
                onValueChange={field.onChange} 
                defaultValue={field.value}
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger className="text-muted-foreground dark:bg-gray-700 dark:border-gray-700 dark:text-white">
                    <SelectValue placeholder={t("form.selectFitnessLevel")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="iniciante">{t("form.fitnessLevels.beginner")}</SelectItem>
                  <SelectItem value="intermediario">{t("form.fitnessLevels.intermediate")}</SelectItem>
                  <SelectItem value="avancado">{t("form.fitnessLevels.advanced")}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage className="dark:text-red-400" />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="initial_assessment_notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-gray-200">{t("form.initialAssessmentNotes")}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={t("form.initialAssessmentNotes")} 
                {...field} 
                className="resize-none min-h-[100px] dark:bg-gray-700 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-400"
              />
            </FormControl>
            <FormMessage className="dark:text-red-400" />
          </FormItem>
        )}
      />
    </div>
  );
};
